import React, { useState } from "react";
import axiosInstance from "../api/axiosConfig.jsx";

const ClockIn = () => {
    const [formData, setFormData] = useState({
        phoneNumber: "",
    });

    const [responseMessage, setResponseMessage] = useState(""); // State voor het opslaan van de respons

    // Input handler voor formulier velden
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
        console.log(`Updated ${e.target.name}:`, e.target.value); // Log elke verandering in de invoervelden
    };

    // Handler voor het submitten van het formulier
    const handleSubmit = async (e) => {
        e.preventDefault();

        const { phoneNumber } = formData;

        // Check of het telefoonnummer is ingevuld
        if (!phoneNumber) {
            console.log("Vul het telefoonnummer in.");
            alert("Vul het telefoonnummer in.");
            return;
        }

        // De API-aanroep naar http://localhost:8080/time/clock
        try {
            const response = await axiosInstance.post("/time/clock", formData);
            console.log("Response:", response.data); // Log het antwoord van de server
            setResponseMessage(response.data); // Sla de respons op in de state
            alert("Verzoek succesvol verzonden");
        } catch (error) {
            console.error("Er ging iets mis tijdens het verzenden van het verzoek", error);
            setResponseMessage("Fout tijdens het verzenden van het verzoek."); // Sla foutbericht op in de state
        }
    };

    // Nummer klikken voor numeriek toetsenbord (werkt alleen voor telefoonnummer)
    const handleNumberClick = (number) => {
        setFormData((prevData) => ({
            ...prevData,
            phoneNumber: prevData.phoneNumber + number, // Voeg nummer toe aan het telefoonnummer
        }));
        console.log("Phone number updated:", formData.phoneNumber + number); // Log elke keer als het telefoonnummer wordt bijgewerkt
    };

    // Backspace-functie om het laatste teken van het telefoonnummer te verwijderen
    const handleBackspaceClick = () => {
        setFormData((prevData) => ({
            ...prevData,
            phoneNumber: prevData.phoneNumber.slice(0, -1), // Verwijder het laatste teken uit het telefoonnummer
        }));
        console.log("Phone number after backspace:", formData.phoneNumber.slice(0, -1)); // Log het telefoonnummer na backspace
    };

    return (
        <div className="container-fluid vh-100 d-flex justify-content-center align-items-center bg-light" style={{ width: "94vw" }}>
            <div className="bg-white p-4 rounded shadow" style={{ maxWidth: "400px", width: "100%" }}>
                <h2 className="text-center mb-4">In- en Uitklokken</h2>
                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label htmlFor="phoneNumber" className="form-label">
                            Telefoonnummer
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="phoneNumber"
                            name="phoneNumber"
                            value={formData.phoneNumber}
                            onChange={handleChange}
                            inputMode="none" // Voorkomt toetsenbord
                            required
                        />
                    </div>

                    {/* Numeriek toetsenbord */}
                    <div className="mb-4">
                        <div className="row g-2">
                            {[1, 2, 3].map((number) => (
                                <div className="col-4" key={number}>
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary w-100 rounded-circle"
                                        style={{ height: '50px', width: '50px', fontSize: '1.2rem' }}
                                        onClick={() => handleNumberClick(number.toString())}
                                    >
                                        {number}
                                    </button>
                                </div>
                            ))}
                            {[4, 5, 6].map((number) => (
                                <div className="col-4" key={number}>
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary w-100 rounded-circle"
                                        style={{ height: '50px', width: '50px', fontSize: '1.2rem' }}
                                        onClick={() => handleNumberClick(number.toString())}
                                    >
                                        {number}
                                    </button>
                                </div>
                            ))}
                            {[7, 8, 9].map((number) => (
                                <div className="col-4" key={number}>
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary w-100 rounded-circle"
                                        style={{ height: '50px', width: '50px', fontSize: '1.2rem' }}
                                        onClick={() => handleNumberClick(number.toString())}
                                    >
                                        {number}
                                    </button>
                                </div>
                            ))}
                            <div className="col-4">
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary w-100 rounded-circle"
                                    style={{ height: '50px', width: '50px', fontSize: '1.2rem' }}
                                    onClick={() => handleBackspaceClick()}
                                >
                                    ⌫
                                </button>
                            </div>
                            <div className="col-4">
                                <button
                                    type="button"
                                    className="btn btn-outline-primary w-100 rounded-circle"
                                    style={{ height: '50px', width: '50px', fontSize: '1.2rem' }}
                                    onClick={() => handleNumberClick("0")}
                                >
                                    0
                                </button>
                            </div>
                            <div className="col-4">
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary w-100 rounded-circle"
                                    style={{ height: '50px', width: '50px', fontSize: '1.2rem' }}
                                    onClick={() => handleNumberClick("*")}
                                >
                                    *
                                </button>
                            </div>
                        </div>
                    </div>

                    <button type="submit" className="btn btn-primary w-100">
                        Verzend
                    </button>
                </form>

                {/* Weergave van de API-respons */}
                {responseMessage && (
                    <div className="mt-4 alert alert-info" role="alert">
                        {responseMessage}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ClockIn;
